/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTumorBoardPatients } from 'app/entities/tumor-board-patient/tumor-board-patient.reducer';
import { getEntities as getTumorBoardOccurrences } from 'app/entities/tumor-board-occurrence/tumor-board-occurrence.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './tumor-board-outcome.reducer';

export const TumorBoardOutcomeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tumorBoardPatients = useAppSelector(state => state.tumorBoardPatient.entities);
  const tumorBoardOccurrences = useAppSelector(state => state.tumorBoardOccurrence.entities);
  const tumorBoardOutcomeEntity = useAppSelector(state => state.tumorBoardOutcome.entity);
  const loading = useAppSelector(state => state.tumorBoardOutcome.loading);
  const updating = useAppSelector(state => state.tumorBoardOutcome.updating);
  const updateSuccess = useAppSelector(state => state.tumorBoardOutcome.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/tumor-board-outcome${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTumorBoardPatients({}));
    dispatch(getTumorBoardOccurrences({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorBoardOutcomeEntity,
      ...values,
      patient: tumorBoardPatients.find(it => it.id.toString() === values.patient?.toString()),
      occurrence: tumorBoardOccurrences.find(it => it.id.toString() === values.occurrence?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          createdByType: 'ACCOUNTANT',
          ...tumorBoardOutcomeEntity,
          patient: tumorBoardOutcomeEntity?.patient?.id,
          occurrence: tumorBoardOutcomeEntity?.occurrence?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorBoardOutcome.home.createOrEditLabel" data-cy="TumorBoardOutcomeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.home.createOrEditLabel">Create or edit a TumorBoardOutcome</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-board-outcome-id"
                  label={translate('tinyMedicRestApp.tumorBoardOutcome.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.createdById')}
                id="tumor-board-outcome-createdById"
                name="createdById"
                data-cy="createdById"
                type="text"
              />
              <UncontrolledTooltip target="createdByIdLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.createdById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.createdByType')}
                id="tumor-board-outcome-createdByType"
                name="createdByType"
                data-cy="createdByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.outcomeSummary')}
                id="tumor-board-outcome-outcomeSummary"
                name="outcomeSummary"
                data-cy="outcomeSummary"
                type="text"
              />
              <UncontrolledTooltip target="outcomeSummaryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.outcomeSummary" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.active')}
                id="tumor-board-outcome-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.cursor')}
                id="tumor-board-outcome-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.lastUpdated')}
                id="tumor-board-outcome-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.microSec')}
                id="tumor-board-outcome-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOutcome.timestampEntry')}
                id="tumor-board-outcome-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOutcome.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-board-outcome-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.tumorBoardOutcome.patient')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardPatients
                  ? tumorBoardPatients.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-outcome-occurrence"
                name="occurrence"
                data-cy="occurrence"
                label={translate('tinyMedicRestApp.tumorBoardOutcome.occurrence')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardOccurrences
                  ? tumorBoardOccurrences.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-board-outcome" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorBoardOutcomeUpdate;
